<div [formGroup]="dateTimeForm" class="flex gap-3">
  <!-- date  -->
  <div class="relative flex items-center flex-2">
    <!-- placeholder has absolute positioning to fix padding consistency -->
    <input
      class="custom-placeholder"
      matInput
      [placeholder]="'notification-form.date-placeholder' | translate"
      [matDatepicker]="picker"
      formControlName="date"
      [min]="minDate"
      (click)="picker.open()"
    />
    <div class="absolute left-2 flex items-center">
      <mat-datepicker-toggle matIconSuffix [for]="picker">
        <fa-icon
          class="flex items-center text-[#CDCDCD] text-xs"
          [icon]="'calendar'"
          matDatepickerToggleIcon
        ></fa-icon>
      </mat-datepicker-toggle>
    </div>
    <mat-datepicker #picker></mat-datepicker>
  </div>
  <!-- time -->
  <div class="relative flex items-center flex-1">
    <!-- placeholder has absolute positioning to fix padding consistency -->
    <input
      class="custom-placeholder"
      matInput
      [placeholder]="'notification-form.time-placeholder' | translate"
      [matTimepicker]="timepicker"
      formControlName="time"
      [matTimepickerMin]="minTime"
      (click)="timepicker.open()"
    />
    <div class="absolute left-2 flex items-center">
      <mat-timepicker-toggle matSuffix [for]="timepicker">
        <fa-icon
          class="flex items-center text-[#CDCDCD]"
          [icon]="'clock'"
          matTimepickerToggleIcon
        ></fa-icon>
      </mat-timepicker-toggle>
      <mat-timepicker interval="15m" #timepicker></mat-timepicker>
    </div>
  </div>

  <ng-content></ng-content>
</div>
